import {
    useGridElementDecoratorActions,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementDecoratorResource';
import React from 'react';
import {
    GridElementResource,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementResource';
import { ProcessAreaResource } from '../../../../resource/resources/artifacts/process_area/processAreaResource';
import { MyLink, RouteInfo } from '../../../router/createdRouter';
import { ActionIcon, Group, Paper, Text } from '@mantine/core';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import type { Route } from '../../../router/route';

export const GridElementNode = <R extends Route>({
                                                     element,
                                                     onEdit,
                                                     onDelete,
                                                     editMode,
                                                     processAreas,
                                                     routeInfo,
                                                     disabled,
                                                 }: {
    element: GridElementResource;
    onEdit: (objectId: string) => void;
    onDelete: (id: string) => void;
    editMode: boolean;
    processAreas: Array<ProcessAreaResource>;
    routeInfo: (processAreaObjectId: string) => RouteInfo<R>;
    disabled: boolean;
}) => {
    const decoratorActions = useGridElementDecoratorActions();
    const decoratorQuery = decoratorActions.useGetSingleResource(element.id);

    return (editMode ?
            <Paper
                withBorder
                style={{ height: '100%', flexGrow: 1 }}
                bg={disabled ? 'var(--mantine-color-read-only-input)' : decoratorQuery.data?.backgroundColor ?? `var(--mantine-primary-color-8)`}
            >
                <Group gap={0} style={{ position: 'fixed', top: 0, right: 0 }}>
                    <ActionIcon
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={() => {
                            onEdit(element.objectId);
                        }}
                        variant={'transparent'}
                        color={disabled ? 'white' : decoratorQuery.data?.textColor === decoratorQuery.data?.backgroundColor ? 'white' : decoratorQuery.data?.textColor ?? 'white'}
                    >
                        <IconPencil />
                    </ActionIcon>
                    <ActionIcon
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={() => onDelete(element.id)}
                        variant={'transparent'}
                        color={disabled ? 'white' : decoratorQuery.data?.textColor === decoratorQuery.data?.backgroundColor ? 'white' : decoratorQuery.data?.textColor ?? 'white'}
                    >
                        <IconTrash />
                    </ActionIcon>
                </Group>
                <div style={{ height: '100%', flexGrow: 1, alignContent: 'center', textAlign: 'center' }}>
                    <Text c={disabled ? 'white' : decoratorQuery.data?.textColor ?? 'white'}>
                        {processAreas.find(pa => pa.objectId === element.processArea)?.name ?? 'null'}
                    </Text>
                </div>
            </Paper> : (disabled ?
                    <Paper
                        withBorder
                        style={{ height: '100%', flexGrow: 1, alignContent: 'center', textAlign: 'center' }}
                        bg={'var(--mantine-color-read-only-input)'}
                    >
                        <Text c={'white'}>
                            {processAreas.find(pa => pa.objectId === element.processArea)?.name ?? 'null'}
                        </Text>
                    </Paper> :
                    <MyLink  {...routeInfo(element.processArea ?? '')}>
                        <Paper
                            withBorder
                            style={{ height: '100%', flexGrow: 1, alignContent: 'center', textAlign: 'center' }}
                            bg={decoratorQuery.data?.backgroundColor ?? `var(--mantine-primary-color-8)`}
                        >
                            <Text c={decoratorQuery.data?.textColor ?? 'white'}>
                                {processAreas.find(pa => pa.objectId === element.processArea)?.name ?? 'null'}
                            </Text>
                        </Paper>
                    </MyLink>
            )

    );
};